var React = require('react');

function IconAccount (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-143.75 -911.75)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"},[React.createElement("path",{"d":"M159.5 920.2a3.5 3.5 0 01-4.152 3.441 3.8 3.8 0 01-2.848-3.612v-1.058a3.8 3.8 0 012.848-3.612 3.5 3.5 0 014.152 3.441z","key":0}),React.createElement("circle",{"cx":"11.5","cy":"11.5","r":"11.5","transform":"translate(144.5 912.5)","key":1}),React.createElement("path",{"d":"M148.16 932.41a8.714 8.714 0 0115.68 0","key":2})]));
}

IconAccount.defaultProps = {"className":"icon-account","width":"24.5","height":"24.5","viewBox":"0 0 24.5 25.5","preserveAspectRatio":"xMidYMid meet"};

module.exports = IconAccount;

IconAccount.default = IconAccount;
